var pullupWin = $(window);
var pullupElements = $(".pullup");

pullupElements.each(function(i, e){
    var element = $(e);
    if (element.visible(true)){
        element.addClass("pullup-visible"); 
    } 
});

pullupWin.scroll(function(event){
    pullupElements = $(".pullup").not(".pullup-visible");
    pullupElements.each(function(i, e){
        var element = $(e);
        if (element.visible(true)){
            element.addClass("come-in"); 
        } 
    });
});


// WEBPACK FOOTER //
// ./js/partials/pullup.js